{
  "visHjelpeskuffAriaLabel": "Gå til hjelp om dette.",
  "unknownError": "En feil har oppstått",
  "unknownErrorAction": "Last siden på nytt!",
  "pendingChangesHeader": "Det finnes endringer som ikke er lagret",
  "pendingChangesClose": "Forkast endringer",
  "pendingChangesConfirm": "Fortsett redigering",
  "pendingChangesDescription": "Hvis du forlater siden, vil du miste alle endringer du har gjort.",
  "languageChanged": "Språk endret til bokmål",
  "breadCrumb_Forsiden": "Forside",
  "pageNotFoundHeader": "Denne siden er visst ikke helt frisk",
  "pageNotFoundDescription": "Se etter en skrivefeil i URL-adressen, eller gå til forsiden.",
  "pageNotFoundToStart": "Gå til forsiden",
  "sharing_Status_Delt_Med_Barnet": "Delt med barnet",
  "sharing_Status_Bare_Synlig_For_Deg": "Bare synlig for deg",
  "word_explanation_open": "Åpne ordforklaring",
  "word_explanation_close": "Lukk ordforklaring",
  "word_explanation_search_description": "Ser du ord eller uttrykk som du ikke forstår, kan du søke her.",
  "word_explanation_search_input_label": "Søk",
  "word_explanation_search_submit_button": "Søk",
  "word_explanation_search_source_prefix": "Kilde:",
  "language_norwegian": "Norsk",
  "language_english": "English",
  "language_sami": "Sámi",
  "language_nynorsk": "Nynorsk",
  "language_lithuanian": "Lietuviškai",
  "language_polish": "Polski",
  "language_russian": "Русский",
  "language_romanian": "Română",
  "language_bokmaal": "Bokmål",
  "visHjelpeskuffTekst": "Mer hjelp",
  "breadcrumb_arialabel": "Brødsmulesti",
  "language_picker_trigger_text": "Språk/Language",
  "language_ukrainian": "Українська",
  "language_french": "Français",
  "word_explanation_search_container_label": "Ordforklaringer",
  "driftspanel_aria_label": "Driftsmeldinger",
  "tjenester_sharingInfo_hjelpetekst": {
    "type": "markdown",
    "value": "Barn med foreldresamtykke har tilgang denne tjenesten. [Les mer om hvilke tjenester barnet ditt har tilgang til](https://www.helsenorge.no/om-tjenestene/foreldresamtykke-ungdomstilgang/)"
  },
  "tjenester_sharingInfo_title": "Hva kan barnet gjøre",
  "sharing_Status_Skjult_For_Barnet": "Skjult for barnet",
  "sharing_Status_Skjult_For_Fullmektig": "Skjult for fullmektig"
}
